export default __webpack_public_path__ + "static/media/image_not_found.00471eab.png";